<template>
  <header class="site-header">
    <router-link class="brand" to="/">
      <img class="brand-mark" :src="logo" alt="易尤特集团 Logo">
      <span class="brand-copy">
        易尤特集团
        <!-- <span>Zhejiang EUT Technology</span> -->
      </span>
    </router-link>

    <el-menu
      class="nav-menu"
      mode="horizontal"
      :default-active="activeIndex"
      menu-trigger="hover"
      background-color="transparent"
      text-color="rgba(255,255,255,.82)"
      active-text-color="#9ee6f4"
      @select="handleNavSelect"
    >
      <template v-for="item in navItems">
        <el-submenu
          v-if="item.children"
          :key="item.key"
          :index="item.key"
          popper-class="nav-submenu-popper"
        >
          <template slot="title">{{ item.label }}</template>
          <el-menu-item v-for="child in item.children" :key="child.key" :index="child.key">
            {{ child.label }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :key="item.key" :index="item.key">{{ item.label }}</el-menu-item>
      </template>
    </el-menu>

    <button class="mobile-menu-button" type="button" aria-label="打开导航" @click="mobileMenuVisible = true">
      <i class="el-icon-menu"></i>
    </button>

    <el-drawer
      class="mobile-nav-drawer"
      :visible.sync="mobileMenuVisible"
      direction="rtl"
      size="82%"
      :with-header="false"
    >
      <div class="mobile-nav-panel">
        <div class="mobile-nav-head">
          <div class="mobile-nav-brand">
            <img :src="logo" alt="易尤特集团 Logo">
            <strong>易尤特集团</strong>
          </div>
          <button class="mobile-close-button" type="button" aria-label="关闭导航" @click="mobileMenuVisible = false">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <nav class="mobile-nav-list" aria-label="移动端导航">
          <template v-for="item in navItems">
            <div v-if="item.children" :key="item.key" class="mobile-nav-group">
              <span>{{ item.label }}</span>
              <a
                v-for="child in item.children"
                :key="child.key"
                :href="menuHref(child)"
                :target="isExternal(child.link) ? '_blank' : null"
                :rel="isExternal(child.link) ? 'noopener noreferrer' : null"
                :class="{ active: activeIndex === child.key }"
                @click="handleMobileSelect($event, child)"
              >
                {{ child.label }}
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
            <a
              v-else
              :key="item.key"
              :href="menuHref(item)"
              :target="isExternal(item.link) ? '_blank' : null"
              :rel="isExternal(item.link) ? 'noopener noreferrer' : null"
              :class="{ active: activeIndex === item.key }"
              @click="handleMobileSelect($event, item)"
            >
              {{ item.label }}
              <i class="el-icon-arrow-right"></i>
            </a>
          </template>
        </nav>
      </div>
    </el-drawer>
  </header>
</template>

<script>
import { getHome, getNavigation } from "@/api/website";

export default {
  name: "AppHeader",
  data() {
    return {
      logo: "/assets/logo.png",
      mobileMenuVisible: false,
      menus: []
    };
  },
  computed: {
    navItems() {
      return this.menus.filter((item) => !item.parentKey).map((item) => {
        if (item.type === "group") {
          return { ...item, children: this.menus.filter((child) => child.parentKey === item.key) };
        }
        return item;
      });
    },
    activeIndex() {
      let path = this.$route.path || "/";
      if (["/business-categories", "/business-detail"].includes(path)) {
        path = "/core-business";
      }
      if (path === "/news-detail") {
        path = "/news";
      }
      const active = this.menus.find((item) => item.type !== "group" && !this.isExternal(item.link)
        && this.$router.resolve(item.link).route.path === path);
      return active ? active.key : "";
    }
  },
  created() {
    getHome().then((res) => {
      this.logo = (res.data && res.data.logo) || this.logo;
    }).catch(() => {});
    getNavigation().then((res) => {
      this.menus = res.data || [];
    }).catch(() => {});
  },
  methods: {
    isExternal(link) {
      return /^https?:\/\//i.test(link || "");
    },
    menuHref(item) {
      return this.isExternal(item.link) ? item.link : this.$router.resolve(item.link).href;
    },
    handleMobileSelect(event, item) {
      this.mobileMenuVisible = false;
      if (!this.isExternal(item.link) && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        this.handleNavSelect(item.key);
      }
    },
    handleNavSelect(index) {
      const selectedItem = this.findNavItem(index, this.navItems);
      if (!selectedItem || selectedItem.children) {
        return;
      }
      if (this.isExternal(selectedItem.link)) {
        window.open(selectedItem.link, "_blank", "noopener,noreferrer");
        return;
      }
      if (selectedItem.link && this.$router.resolve(selectedItem.link).route.fullPath !== this.$route.fullPath) {
        this.$router.push(selectedItem.link);
      }
    },
    findNavItem(index, items) {
      for (const item of items) {
        if (item.key === index) {
          return item;
        }
        if (item.children) {
          const child = this.findNavItem(index, item.children);
          if (child) {
            return child;
          }
        }
      }
      return null;
    }
  },
  watch: {
    $route() {
      this.mobileMenuVisible = false;
    }
  }
};
</script>

<style lang="less">
.site-header {
  position: fixed;
  inset: 0 0 auto;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 15px clamp(22px, 5vw, 76px);
  color: var(--white);
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
  background: linear-gradient(180deg, rgba(4, 26, 53, 0.9), rgba(4, 37, 74, 0.36));
  backdrop-filter: blur(10px);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  font-size: 18px;
  font-weight: 900;
  white-space: nowrap;
}

.brand-mark {
  width: 65px;
  height: auto;
  object-fit: contain;
  flex: 0 0 auto;
}

.brand-copy {
  display: grid;
  gap: 1px;
}

.brand-copy > span {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
  opacity: 0.72;
  text-transform: uppercase;
}

.nav-menu {
  margin-left: auto;
  min-width: 0;
  border-bottom: 0 !important;
}

.nav-menu.el-menu--horizontal > .el-menu-item,
.nav-menu.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: auto;
  line-height: 1.2;
  padding: 0 12px 0;
  border-bottom: 0 !important;
  font-size: 14px;
  font-weight: 700;
  background: transparent !important;
}

.nav-menu.el-menu--horizontal > .el-menu-item.is-active,
.nav-menu.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 0 !important;
}

.nav-menu.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.nav-menu.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.nav-menu.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: transparent !important;
}

.nav-menu.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-left: 6px;
  color: rgba(255, 255, 255, 0.72);
}

.nav-submenu-popper {
  top:65px !important;
  min-width: 128px;
  margin-top: 15px !important;
  border: 0;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(4, 26, 53, 0.84);
  box-shadow: 0 14px 30px rgba(4, 26, 53, 0.2);
}

.nav-submenu-popper .el-menu {
  padding: 6px 0;
}

.nav-submenu-popper .el-menu-item {
  height: 38px;
  line-height: 38px;
  color: var(--navy);
  font-size: 14px;
  font-weight: 700;
}

.nav-submenu-popper .el-menu-item:hover,
.nav-submenu-popper .el-menu-item:focus {
  background: rgba(32, 184, 218, 0.1) !important;
  color: var(--aqua);
}

.mobile-menu-button,
.mobile-close-button {
  display: none;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--white);
  cursor: pointer;
}

.mobile-menu-button {
  width: 42px;
  height: 42px;
  margin-left: auto;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  font-size: 20px;
}

.mobile-nav-drawer .el-drawer {
  background: #071e3a;
  color: var(--white);
}

.mobile-nav-panel {
  min-height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 18px;
  background:
    linear-gradient(180deg, rgba(9, 48, 91, 0.96), rgba(5, 24, 47, 0.98));
}

.mobile-nav-head,
.mobile-nav-brand {
  display: flex;
  align-items: center;
}

.mobile-nav-head {
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.mobile-nav-brand {
  gap: 10px;
  font-size: 16px;
}

.mobile-nav-brand img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.mobile-close-button {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  font-size: 18px;
}

.mobile-nav-list {
  display: grid;
  align-content: start;
  gap: 10px;
  padding-top: 22px;
}

.mobile-nav-list a,
.mobile-nav-group > span {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 14px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.84);
  font-size: 15px;
  font-weight: 800;
}

.mobile-nav-group {
  display: grid;
  gap: 8px;
}

.mobile-nav-group > span {
  background: rgba(255, 255, 255, 0.06);
}

.mobile-nav-group a {
  margin-left: 14px;
}

.mobile-nav-list a.active {
  background: rgba(32, 184, 218, 0.18);
  color: #9ee6f4;
}

@media (max-width: 1040px) {
  .site-header {
    flex-wrap: wrap;
    gap: 12px;
    padding-bottom: 12px;
  }

  .nav-menu {
    order: 3;
    width: 100%;
    margin-left: 0;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scrollbar-width: none;
  }

  .nav-menu::-webkit-scrollbar {
    display: none;
  }

  .nav-menu.el-menu--horizontal {
    display: flex;
    flex-wrap: nowrap;
  }

  .nav-menu.el-menu--horizontal > .el-menu-item,
  .nav-menu.el-menu--horizontal > .el-submenu .el-submenu__title {
    flex: 0 0 auto;
    padding: 0 14px;
    font-size: 14px;
  }

  .mobile-menu-button {
    display: none;
  }
}

@media (max-width: 680px) {
  .site-header {
    padding: 10px 12px 8px;
  }

  .brand {
    gap: 10px;
    font-size: 13px;
    white-space: normal;
  }

  .brand-mark {
    width: 34px;
    height: 34px;
  }

  .brand-copy > span {
    display: none;
  }

  .nav-menu.el-menu--horizontal > .el-menu-item,
  .nav-menu.el-menu--horizontal > .el-submenu .el-submenu__title {
    min-height: 32px;
    display: inline-flex;
    align-items: center;
    padding: 0 9px;
    font-size: 12px;
  }
}
</style>
